module.exports = __webpack_public_path__ + "static/media/onsurance-avatar.7611e29e.png";